var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57212 13.1424L7.76624 12.4179L7.76516 12.4177L7.57212 13.1424ZM6.15323 11.6764C5.81177 11.442 5.34488 11.5287 5.11042 11.8702C4.87596 12.2117 4.96271 12.6785 5.30418 12.913L6.15323 11.6764ZM7.37801 13.8668C10.979 14.8317 14.6802 12.6949 15.645 9.09387L14.1961 8.70564C13.4457 11.5064 10.567 13.1684 7.76624 12.4179L7.37801 13.8668ZM15.645 9.09387C16.6099 5.49289 14.473 1.79173 10.8721 0.826844L10.4838 2.27573C13.2846 3.0262 14.9466 5.90486 14.1961 8.70564L15.645 9.09387ZM10.8721 0.826844C7.27108 -0.138036 3.56992 1.99883 2.60504 5.59981L4.05393 5.98804C4.80439 3.18726 7.68305 1.52526 10.4838 2.27573L10.8721 0.826844ZM5.30418 12.913C5.93383 13.3453 6.63513 13.669 7.37908 13.8671L7.76516 12.4177C7.18722 12.2637 6.6424 12.0123 6.15323 11.6764L5.30418 12.913ZM2.60504 5.59981C2.40121 6.3605 2.33573 7.12742 2.39393 7.87256L3.88937 7.75575C3.84425 7.17799 3.89479 6.58194 4.05393 5.98804L2.60504 5.59981Z",
    fill: "#9DA1B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62912 6.47579L3.44885 8.93508L0.999903 6.76397",
    fill: "#9DA1B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62912 6.47579L3.44885 8.93508L0.999903 6.76397",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15942 5.09375V8.09375H12.1594",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.a7597fa6edd15ccd71b5da328fc7983a.svg";
export { ForwardRef as ReactComponent };